import { useEffect, useMemo } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import type { PricingConfiguration } from "@core";
import { repositoryHost } from "@repositories";
import { serviceHost } from "@services";
import { pricingConfigurationQueryKey } from "./query-keys";

const PRICING_CONFIGURATION_ID = "pricing-configuration";

export const usePricingConfiguration = () => {
  const queryClient = useQueryClient();

  const repository = useMemo(
    () =>
      repositoryHost.getPricingConfigurationRepository(
        serviceHost.getDatabaseService(),
      ),
    [],
  );

  const queryResult = useQuery<PricingConfiguration | null>({
    queryKey: pricingConfigurationQueryKey(),
    queryFn: async () => repository.get({ id: PRICING_CONFIGURATION_ID }),
  });

  useEffect(() => {
    return repository.subscribe({
      id: PRICING_CONFIGURATION_ID,
      callback: (entry) => {
        queryClient.setQueryData(pricingConfigurationQueryKey(), entry);
      },
    });
  }, [queryClient, repository]);

  return queryResult;
};
